import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { http, formatErr } from "../../lib/api";
import { useBrand } from "../../contexts/BrandContext";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

/**
 * Conferma del cambio email via token (SHA-256 lato backend).
 * La sessione corrente viene revocata: si torna al login.
 */
export default function PlatformVerifyEmail() {
  const { brand } = useBrand();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("pending"); // pending | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    (async () => {
      if (!token) { setState("error"); setMsg("Token mancante."); return; }
      try {
        await http.post("/auth/confirm-email-change", { token });
        setState("ok");
        setMsg("Email confermata. Effettua di nuovo il login.");
      } catch (err) {
        setState("error");
        setMsg(formatErr(err));
      }
    })();
  }, [params]);

  return (
    <div data-testid="platform-verify-email-page" className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "linear-gradient(135deg, var(--brand-dark) 0%, #2d1526 100%)", color: "white" }}>
      <div className="w-full max-w-md p-8 rounded-2xl border border-white/10 text-center" style={{ background: "rgba(255,255,255,0.04)" }}>
        <h1 className="font-serif text-2xl mb-4">{brand.display_name}</h1>
        {state === "pending" && <Loader2 className="w-8 h-8 animate-spin mx-auto" />}
        {state === "ok" && <CheckCircle2 className="w-10 h-10 mx-auto" style={{ color: "var(--brand-accent)" }} />}
        {state === "error" && <XCircle className="w-10 h-10 mx-auto text-rose-400" />}
        <p className="text-sm text-white/70 mt-4">{msg}</p>
        {state !== "pending" && (
          <button onClick={() => nav("/platform/login", { replace: true })}
            className="mt-6 px-4 py-2 rounded-lg text-sm" style={{ background: "var(--brand-primary)", color: "white" }}>
            Vai al login
          </button>
        )}
      </div>
    </div>
  );
}
